module.exports = __webpack_public_path__ + "static/media/26.e6cd9610.jpg";